import { Button, Card, CardActionArea, CardContent, CardMedia, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Paper } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'; // Or any other icon
import axios from 'axios';
import { FunctionComponent, useEffect, useRef, useState } from 'react';
import { useHistory } from "react-router-dom";
import { useStore } from '../../store';
import { ApiResponse } from '../../types';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
    height: "100%",
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    transition: 'transform 0.2s',
    '&:hover': {
      transform: 'scale(1.03)',
      boxShadow: theme.shadows[4],
    }
  },
  cardMedia: {
    height: 140,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2),
    backgroundColor: '#ADD8E6',
    backgroundSize: 'contain',
  },
  cardContent: {
    backgroundColor: '#ADD8E6',
  },
  accordian: {
    margin: theme.spacing(1, 0),
    borderRadius: "8px",
    backgroundColor: "#cbe8ff",
    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)', '&:before': {
      display: 'none',
    }
  },
  summary: {
    backgroundColor: "#cbe8ff",
    borderBottom: "1px solid #ddd",
    borderRadius: "8px 8px 0 0"
  },
  details: {
    padding: theme.spacing(2),
    backgroundColor: "#fff",
    borderRadius: "0 0 8px 8px"
  },
  englishTitle: {
    fontSize: '1.4rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
    },
    fontWeight: 600,
  },
  bengaliTitle: {
    fontSize: '1.4rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
    },
  }
}));

type NoticeApiData = {
  desc: string;
  validUpto: string;
  notifyUpto: string;
  createdOn: string;
  attachmentUrl: string;
}

type NoticeState = {
  loading: boolean,
  error: string,
  notices: Array<NoticeApiData>
}


export type TileNavigationProps = {
  tiles: Array<{ section: string, services: Array<{ title: string, logo: string, to: string, detail: string }> }>,
  optTaxRegimeBegin: boolean
  optTaxRegimeEligible: boolean
}

export const TileNavigation: FunctionComponent<TileNavigationProps> = ({ tiles, optTaxRegimeBegin, optTaxRegimeEligible }) => {
  const classes = useStyles();
  const history = useHistory();
  const [eligiblePopup, setEligiblePopup] = useState(false);
  const dialogRef = useRef();
  const store = useStore();
  const [expandedAccordion, setExpandedAccordion] = useState<number | null>(() => {
    const saved = localStorage.getItem("expandedAccordion");
    return saved !== null ? parseInt(saved, 10) : null;
  });

  const [noticesData, setNotices] = useState<NoticeState>({ loading: true, error: '', notices: [] });

  useEffect(() => {
    fetchNotices()
  }, []);

  const handleAccordionChange = (panelIndex: number) => {
    setExpandedAccordion((prev) => {
      const newExpanded = prev === panelIndex ? null : panelIndex;
      localStorage.setItem("expandedAccordion", newExpanded === null ? "" : String(newExpanded));
      return newExpanded;
    });
  };
  const fetchNotices = async () => {
    axios.get<ApiResponse<{ notices: NoticeApiData[] }>>(`api/noti/valid-notices`, {
      headers: {
        'Authorization': `Bearer ${store.auth.jwt}`, 'JWT': `Bearer ${store.auth.jwt}`
      }
    })
      .then(
        ({ data: resp }) => {
          if (resp.status === "success") {
            const baseUrl= String(process.env.REACT_APP_API_ROOT)+"media/notices/";
            console.log(baseUrl);
            const updateNotices = resp.data.notices.map(notice =>({
              ...notice,
              attachmentUrl: `${baseUrl}${notice.attachmentUrl.split("/").pop() ||''}`
            }));
            // const notices: NoticeApiData[] = resp.data.notices;
            console.log("notices", updateNotices);
            setNotices({ loading: false, error: '', notices: updateNotices })
          } else {
            setNotices({ loading: false, error: resp.message, notices: [] })
          }
        },
        () => { setNotices({ loading: false, error: "Network Error", notices: [] }) }
      )
  }

  return (
    <Grid
      style={{ width: "100%" }}
      container
      spacing={2}
      direction="column"
      justify="space-evenly"
      alignItems="stretch">
      {
        tiles.map(({ section, services }, idxOuter) => (
          <Accordion key={idxOuter} expanded={expandedAccordion === idxOuter} onChange={() =>
            handleAccordionChange(idxOuter)
          } className={classes.accordian} >
            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
              <Typography variant="h6">{section}</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.details}>
              <Grid container spacing={3} direction="row" justify="flex-start" alignItems="stretch">
                {services.map(({ title, logo, to, detail }, idxInner) => {
                  if ((!optTaxRegimeBegin || !store.auth.user?.id?.startsWith("800")) && detail === "opt-tax-regime") {
                    return null;
                  } else {
                    return (
                      <Grid item xs={6} sm={6} md={4} key={idxInner}>
                        <Card className={classes.root} onClick={() => {
                          if (detail === "opt-tax-regime" && !optTaxRegimeEligible) {
                            setEligiblePopup(true);
                          }
                          else if (to.startsWith("http")) {
                            window.open(to, "_blank");
                          }
                          else {
                            history.push(to);
                          }
                        }}>
                          <CardActionArea>
                            <CardMedia
                              className={classes.cardMedia}
                              image={logo}
                              title={title}
                            />
                            <CardContent>
                              <Typography gutterBottom variant="h6" component="h2" color="primary" align="center"
                                className={classes.englishTitle}>
                                {title.split('(')[0]}
                              </Typography>
                              <Typography variant="h5" align="center" color="primary"
                                className={classes.bengaliTitle}>
                                ({title.split('(')[1]?.replace(')', '').trim()})
                              </Typography>
                              {/* <Typography variant="body2" color="textSecondary" component="p" align="center"> */}
                                {/* {detail} */}
                              {/* </Typography> */}
                            </CardContent>
                          </CardActionArea>
                        </Card>
                      </Grid>
                    );
                  }
                })}
              </Grid>
            </AccordionDetails>
          </Accordion>
        ))}

      <Accordion expanded={expandedAccordion === tiles.length} onChange={() =>
        setExpandedAccordion(prev => (prev === tiles.length ? null : tiles.length))
      } className={classes.accordian}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
          <Typography variant='h6'>
            Notice Board (বিজ্ঞপ্তি)
          </Typography>
        </AccordionSummary>
        <AccordionDetails style={{ display: "block" }}>
          <Grid container spacing={2} direction='column'>
            {noticesData?.notices?.length > 0 ? (
              noticesData?.notices?.map((notice, index) => (
                <Grid item xs={12} key={index}>
                  <Paper elevation={3} style={{ padding: 16, width: "100%" }}>
                    <Typography variant='body1'>{notice.desc}</Typography>
                    {notice.attachmentUrl && (
                      <Button
                        variant="outlined"
                        href={notice.attachmentUrl}
                        download={notice.attachmentUrl.split("/").pop()}
                        rel="noopener noreferrer"
                        style={{ marginTop: "8px" }} >
                        View Attachment
                      </Button>
                    )}
                  </Paper>
                </Grid>
              ))

            ) : (
              <Typography>Currently notices are not available. (বর্তমানে বিজ্ঞপ্তি উপলব্ধ নেই।)</Typography>
            )}
          </Grid>

        </AccordionDetails>
      </Accordion>

      <Dialog
        open={eligiblePopup}
        onClose={() => setEligiblePopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        ref={dialogRef}
      >
        <DialogTitle id="alert-dialog-title">{"Alert (সতর্কতা)"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            This application can be used only once in a financial year. You can't opt tax regime now since the time window for this has already elapsed. (আপনি এখন করব্যবস্থা বেছে নিতে পারবেন না কারণ এর জন্য বরাদ্দ সময় ইতিমধ্যেই শেষ হয়ে গেছে৷)
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={() => { setInfoAlertOpen(false) }} color="primary">
                            No (না)
                        </Button> */}
          <Button onClick={() => setEligiblePopup(false)} color="primary" autoFocus>
            Ok (ঠিক আছে)
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  )
}